import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { 
    path: 'register', 
    loadComponent: () => import('./view/register/register.component').then(m => m.RegisterComponent)
  },
  { 
    path: 'login', 
    loadComponent: () => import('./view/login/login.component').then(m => m.LoginComponent)
  },
  { 
    path: 'recoverypassword', 
    loadComponent: () => import('./view/recoverypassword/recoverypassword.component').then(m => m.RecoverypasswordComponent)
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule]
})
export class AuthRoutingModule {}
